import { object, mixed ,array} from "yup";

export const watchListMultipleSearchValidationSchema = object().shape({
  file: mixed().required(" [File] is required! "),
  minimumMatchingPercentage: mixed().required(
    " [Matching Percentage] is required! "
  ),
  watchListTypes: array().required(
    " [Watchlist Type/s] is required! "
  ),
});



// WEBPACK FOOTER //
// ./src/features/watch-list-entry/validation-schemas/watchListMultipleSearchEntriesValidationSchema.js